import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SurveysService } from '../../../services/surveys.service';
import { AddEditQuestionDialogComponent } from './dialogs/add-edit-question-dialog.component';
import { DeleteDialogComponent } from '../../../shared/delete-dialog/delete.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-embedded-questions',
    templateUrl: './embedded-questions.component.html',
    styleUrls: ['./embedded-questions.component.scss'],
    standalone: false
})
export class EmbeddedQuestionsComponent implements OnInit {

  displayedColumns: string[] = ['questionText', 'questionType', 'dateUpdated', 'updatedBy', 'action'];
  dataSource: any[] = [];

  constructor(
    private surveysService: SurveysService,
    private toaster: ToastrService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getEmbeddedQuestions();
  }

  getEmbeddedQuestions(): void {
    this.surveysService.getEmbeddedQuestions().subscribe((questions: any) => {
      this.dataSource = questions.body;
    });
  }

  addQuestion(): void {
    const dialogRef = this.dialog.open(AddEditQuestionDialogComponent, {
      width: '350px',
      data: { title: 'Add Embedded Question', questionText: '', questionType: 'Extracted Question-Multiple Choice' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.surveysService.addEmbeddedQuestion(result.questionText, result.questionType).subscribe(() => {
          this.getEmbeddedQuestions();
        });
      }
    });
  }

  editQuestion(question: any): void {
    const dialogRef = this.dialog.open(AddEditQuestionDialogComponent, {
      width: '350px',
      data: { title: 'Edit Embedded Question', questionText: question.questionText, update: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.surveysService.updateEmbeddedQuestion(question.questionId, result.questionText).subscribe(() => {
          this.toaster.info(`Question should be removed and 
            re added to the survey. Survey links then need not be re created`, 'Info', { disableTimeOut: true, closeButton: true });
          this.getEmbeddedQuestions();
        });
      }
    });
  }

  deleteQuestion(question: any): void {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '250px',
      data: { title: 'Delete Embedded Question', message: 'Are you sure you want to delete this question?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.surveysService.deleteEmbeddedQuestion(question.questionId).subscribe(() => {
          this.toaster.info(`If this question was added to any of 
            the Surveys then, it needs to be removed manually. This will not break any surveys using this question on survey links`, 'Info',
            {
              disableTimeOut: true,
              closeButton: true
            });
          this.getEmbeddedQuestions();
        });
      }
    });
  }
}
